// extracted by mini-css-extract-plugin
export default {"container":"azjd8V","vertical":"HQrCPw","horizontal":"rJtQAq","item":"xwKkCZ","notHovered":"qbr4bW","indicator":"sZPliY","text":"pTeR8Q"};